import { pageUrl } from '../seo/site';

// Actualiza el <title>, la meta description, el canonical y las etiquetas
// Open Graph/Twitter al navegar entre páginas dentro de la SPA. El HTML
// inicial de cada ruta ya trae todo esto desde el build (scripts/prerender.mjs);
// esto solo lo mantiene correcto cuando React cambia de ruta sin recargar.
const upsert = (selector, create, attr, value) => {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = create();
    document.head.appendChild(tag);
  }
  tag.setAttribute(attr, value);
};

const metaTag = (key, keyAttr) => () => {
  const tag = document.createElement('meta');
  tag.setAttribute(keyAttr, key);
  return tag;
};

const setPageMeta = ({ title, description, path }) => {
  const url = pageUrl(path);
  document.title = title;

  upsert('meta[name="description"]', metaTag('description', 'name'), 'content', description);
  upsert('link[rel="canonical"]', () => {
    const link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    return link;
  }, 'href', url);

  upsert('meta[property="og:title"]', metaTag('og:title', 'property'), 'content', title);
  upsert('meta[property="og:description"]', metaTag('og:description', 'property'), 'content', description);
  upsert('meta[property="og:url"]', metaTag('og:url', 'property'), 'content', url);
  upsert('meta[name="twitter:title"]', metaTag('twitter:title', 'name'), 'content', title);
  upsert('meta[name="twitter:description"]', metaTag('twitter:description', 'name'), 'content', description);
};

export default setPageMeta;
